module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/hero_mob-b2d0596c76ca975feb001877deffc061.jpg";